<script lang="ts">
export default {
  name: 'KkInsertParameter',
}
</script>

<script setup lang="ts">
import { onBeforeUnmount , ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { KkLoading, KkIcon } from '../../../components/base'
import { KkAddLabel } from '../../../components/ui'
import { actionEvent } from 'src/biz_spa/modules/googleAnalytics'

interface Props {
  parameters?: string[]
  loading?: boolean
}

interface Emits {
  (e: 'insert-parameter', parameterName: string): void
}

const props = withDefaults(defineProps<Props>(), {
  parameters: () => [],
  loading: false
})
const emit = defineEmits<Emits>()

const { t } = useI18n()
const { path } = useRoute()

const showParameterList = ref<boolean>(false)
const searchedText = ref<string>('')
const showedParameters = computed<string[]>(() => props.parameters.filter(v => v.toLowerCase().indexOf(searchedText.value.toLowerCase()) !== -1))

const openParameterList = () => {
  showParameterList.value = true
  if(path.includes('/posts/new')) {
    actionEvent('LoadParameter')
  }
}

const closeParameterList = (event: Event) => {
  if (!(event.target as Element).closest('.insertParameter')) {
    showParameterList.value = false
  }
}

const selectParameter = (name: string) => {
  emit('insert-parameter', `{${name}}`)
  showParameterList.value = false
}

const load = () => {
  document.addEventListener('click', closeParameterList)
}

onBeforeUnmount(() => {
  window.removeEventListener('click', closeParameterList)
})

load()
</script>

<template>
  <div class="insertParameter">
    <KkAddLabel
      :label="t('labels.readParameters')"
      @click="openParameterList"
    />
    <div v-if="showParameterList" class="insertParameter__content">
      <KkLoading v-if="props.loading" min-height="120px" />
      <template v-else>
        <div class="p-reviews__reply__template__content__search">
          <span>
            <KkIcon name="search" color="#3A3B3F" />
          </span>
          <input v-model="searchedText" type="text">
        </div>
        <div v-if="showedParameters.length" class="p-reviews__reply__template__content__items">
          <button
            v-for="(parameter, k) in showedParameters"
            :key="`parameter_${k}`"
            type="button"
            class="p-reviews__reply__template__content__item"
            @click="selectParameter(parameter)"
          >
            {{ parameter }}
          </button>
        </div>
        <p
          v-else
          class="p-reviews__reply__template__content__noData"
        >
          {{ t('labels.noParameter') }}
        </p>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
.insertParameter {
  position: relative;
  margin-bottom: 4px;
  &__content {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    width: 240px;
    height: 310px;
    border-radius: 4px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, .05);
    overflow-y: scroll;
    background: #FFF;
    &__item,
    &__noData {
      width: 100%;
      padding: 12px 24px;
      font-size: 14px;
      line-height: 1.72;
      text-align: left;
      word-break: break-all;
    }
    &__item {
      transition: .3s;
      &:hover {
        background-color: #EEE;
      }
    }
  }
}
</style>
